"use client";
import { Button } from "@ampol/design-system";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import * as React from "react";
import { Container } from "../Container";

interface NavigationProps {
  children?: React.ReactNode;
  className?: string;
}

export function Navigation({ children }: NavigationProps): JSX.Element {
  const { instance } = useMsal();
  return (
    <>
      <Container className="sticky top-[0px] bg-white z-10">
        <nav className="flex justify-between items-center h-[95px] mobile:h-[130px] w-full">
          <a href="https://ampcharge.ampol.com.au/ ">
            <img
              alt="ampol logo"
              className="w-[188px]"
              id="nav-logo"
              src="/driver-portal/ampcharge-logo.png"
            />
          </a>
          <div className="flex space-x-l">
            <UnauthenticatedTemplate>
              <a href="/">
                <Button
                  color="cobalt"
                  label="Login"
                  onClick={() => {
                    void instance.loginRedirect();
                  }}
                  variant="tertiary"
                />
              </a>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
              {/* Not very accessible :( */}
              <div
                className="w-s h-s bg-icon-logout bg-cover hover:cursor-pointer"
                onClick={() => {
                  void instance.logoutRedirect({
                    postLogoutRedirectUri: "https://ampcharge.ampol.com.au/charging-at-home"
                  });
                }}
              />
            </AuthenticatedTemplate>
          </div>
        </nav>
      </Container>
      <div className="relative">{children}</div>
    </>
  );
}
